import React, { useEffect } from 'react';
import { Button as SaladButton, Row } from 'saladsoft-primitive';

import styled from 'styled-components';

// SaladButton의 props 타입을 확장
type ButtonProps = React.ComponentProps<typeof SaladButton> & {
  children: React.ReactNode;
  style?: React.CSSProperties;
  isValid?: boolean;
};

const Button = ({ children, style, isValid = true, onClick, ...props }: ButtonProps) => {
  return (
    <ButtonContainer isValid={isValid} style={style} {...props} onClick={onClick}>
      <Row gap={10}>
        <>{children}</>
      </Row>
    </ButtonContainer>
  );
};

const ButtonContainer = styled(SaladButton) <{ isValid?: boolean }>`
  background: ${({ isValid }) => (!isValid ? '#d5d5d5' : 'var(--point-color)')};
  color: ${({ isValid }) => (!isValid ? '#9d9d9d' : '#fff')};
  display: inline-flex;
  margin: 0;
  padding: 10px 20px;
  &:hover {
    background: ${({ isValid }) => (!isValid ? '#d5d5d5' : '#730000')};
  }
`;
export default Button;
